import index from './_index'

export default index
